"use strict";

var _defineProperty = require("/home/circleci/repo/app/ui-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _Nodes;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NodeNames_1 = require("../enum/NodeNames");

var ParseError_1 = require("../errors/ParseError");

var AssignNode_1 = require("../nodes/AssignNode");

var AttemptNode_1 = require("../nodes/AttemptNode");

var BreakNode_1 = require("../nodes/BreakNode");

var CommentNode_1 = require("../nodes/CommentNode");

var CompressNode_1 = require("../nodes/CompressNode");

var ConditionNode_1 = require("../nodes/ConditionNode");

var EscapeNode_1 = require("../nodes/EscapeNode");

var FlushNode_1 = require("../nodes/FlushNode");

var FtlNode_1 = require("../nodes/FtlNode");

var FunctionNode_1 = require("../nodes/FunctionNode");

var GlobalNode_1 = require("../nodes/GlobalNode");

var ImportNode_1 = require("../nodes/ImportNode");

var IncludeNode_1 = require("../nodes/IncludeNode");

var InterpolationNode_1 = require("../nodes/InterpolationNode");

var ListNode_1 = require("../nodes/ListNode");

var LocalNode_1 = require("../nodes/LocalNode");

var LtNode_1 = require("../nodes/LtNode");

var MacroCallNode_1 = require("../nodes/MacroCallNode");

var MacroNode_1 = require("../nodes/MacroNode");

var NoEscapeNode_1 = require("../nodes/NoEscapeNode");

var NtNode_1 = require("../nodes/NtNode");

var ReturnNode_1 = require("../nodes/ReturnNode");

var RtNode_1 = require("../nodes/RtNode");

var SettingNode_1 = require("../nodes/SettingNode");

var StopNode_1 = require("../nodes/StopNode");

var SwitchCaseNode_1 = require("../nodes/SwitchCaseNode");

var SwitchDefaultNode_1 = require("../nodes/SwitchDefaultNode");

var SwitchNode_1 = require("../nodes/SwitchNode");

var TextNode_1 = require("../nodes/TextNode");

var TNode_1 = require("../nodes/TNode");

var Nodes = (_Nodes = {}, _defineProperty(_Nodes, NodeNames_1.default.Else, function (token, parent) {
  if (parent instanceof ConditionNode_1.default && !parent.alternate) {
    parent.alternate = [];
    return parent;
  } else if (parent instanceof ListNode_1.default && !parent.fallback) {
    parent.fallback = [];
    return parent;
  }

  throw new ParseError_1.default("Error while creating node '".concat(NodeNames_1.default.Else, "' inside '").concat(parent.type, "'"), token);
}), _defineProperty(_Nodes, NodeNames_1.default.Condition, function (token) {
  return new ConditionNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.ConditionElse, function (token, parent) {
  if (parent instanceof ConditionNode_1.default && !parent.alternate) {
    parent.alternate = [];
    return new ConditionNode_1.default(token);
  }

  throw new ParseError_1.default("Error while creating node '".concat(NodeNames_1.default.ConditionElse, "' inside '").concat(parent.type, "'"), token);
}), _defineProperty(_Nodes, NodeNames_1.default.Recover, function (token, parent) {
  if (parent instanceof AttemptNode_1.default) {
    if (!parent.fallback) {
      parent.fallback = [];
      return parent;
    }
  }

  throw new ParseError_1.default("Error while creating node '".concat(NodeNames_1.default.Recover, "' inside '").concat(parent.type, "'"), token);
}), _defineProperty(_Nodes, NodeNames_1.default.SwitchCase, function (token, parent) {
  if (parent instanceof SwitchNode_1.default) {
    parent.cases.push(new SwitchCaseNode_1.default(token));
    return parent;
  }

  throw new ParseError_1.default("Error while creating node '".concat(NodeNames_1.default.SwitchCase, "' inside '").concat(parent.type, "'"), token);
}), _defineProperty(_Nodes, NodeNames_1.default.SwitchDefault, function (token, parent) {
  if (parent instanceof SwitchNode_1.default) {
    parent.cases.push(new SwitchDefaultNode_1.default(token));
    return parent;
  }

  throw new ParseError_1.default("Error while creating node '".concat(NodeNames_1.default.SwitchDefault, "' inside '").concat(parent.type, "'"), token);
}), _defineProperty(_Nodes, NodeNames_1.default.Global, function (token) {
  return new GlobalNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.Local, function (token) {
  return new LocalNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.Assign, function (token) {
  return new AssignNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.Function, function (token) {
  return new FunctionNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.Return, function (token) {
  return new ReturnNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.Attempt, function (token) {
  return new AttemptNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.List, function (token) {
  return new ListNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.Macro, function (token) {
  return new MacroNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.Include, function (token) {
  return new IncludeNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.Interpolation, function (token) {
  return new InterpolationNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.Text, function (token) {
  return new TextNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.MacroCall, function (token) {
  return new MacroCallNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.Comment, function (token) {
  return new CommentNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.Switch, function (token) {
  return new SwitchNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.Break, function (token) {
  return new BreakNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.Compress, function (token) {
  return new CompressNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.Import, function (token) {
  return new ImportNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.Stop, function (token) {
  return new StopNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.Setting, function (token) {
  return new SettingNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.Rt, function (token) {
  return new RtNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.Lt, function (token) {
  return new LtNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.Nt, function (token) {
  return new NtNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.T, function (token) {
  return new TNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.Flush, function (token) {
  return new FlushNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.Escape, function (token) {
  return new EscapeNode_1.default(token);
}), _defineProperty(_Nodes, NodeNames_1.default.NoEscape, function (token, parent) {
  if (parent instanceof EscapeNode_1.default || parent instanceof NoEscapeNode_1.default) {
    return new NoEscapeNode_1.default(token);
  }

  throw new ParseError_1.default("Error while creating node '".concat(NodeNames_1.default.NoEscape, "' inside '").concat(parent.type, "'"), token);
}), _defineProperty(_Nodes, NodeNames_1.default.Ftl, function (token) {
  return new FtlNode_1.default(token);
}), _Nodes);
exports.default = Nodes;